/* eslint-disable no-new */
/* eslint-disable no-new-func */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-eval */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import {
  CalculatorContainer,
  CalculatorTitle,
  Container,
  Main,
  ClearButton,
  TitleContainer,
  ContentContainer,
  // @ts-ignore
} from "./style";
import CalculatorBasicInput from "../../components/molecules/CalculatorBasicInput";
import CalculatorMultipleOptions from "../../components/molecules/CalculatorMultipleOptions";
// @ts-ignore
import { BBLoadingGif } from "../../blackbook-components/quarks/blackbook-loading";
import CalcDosResults from "../../components/organisms/CalculatorResults/calcDosResults";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_DOSAGE_CALCULATORS } from "../../services/clients/bffConfig/querys/DosageCalculatorQuery";

interface IProps {
  calcName: string;
}

const CalcDos = (props: IProps) => {
  const [inputValues, setInputValues] = useState<any>({});
  const [parsedExpressions, setParsedExpressions] = useState<any>({});
  const parsedExpressionsRef = useRef<any>({});
  const [results, setResults] = useState<any>();
  const [secondaryResults, setSecondaryResults] = useState<any>();
  const [initialState, setInitialState] = useState(true);
  const [fieldsComplete, setFieldsComplete] = useState(false);
  const [calcContent, setCalcContent] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const [fetchCalculators, { data: calculatorsData }] = useLazyQuery(
    GET_ALL_DOSAGE_CALCULATORS,
    {
      fetchPolicy: "cache-first",
      onCompleted: (data) => {
        console.log("[CalcDos] Query completed", data);
        if (data?.getAllDosageCalculators) {
          console.log("[CalcDos] Found calculators:", data.getAllDosageCalculators.length);
          findCalculatorFromData(data.getAllDosageCalculators);
        } else {
          console.warn("[CalcDos] No calculators found in response");
          setLoading(false);
        }
      },
      onError: (error) => {
        console.error("[CalcDos] Fetch error:", error);
        setLoading(false);
      },
    }
  );

  function findCalculatorFromData(calculators: any[]) {
    console.log("[CalcDos] Searching for calculator with name:", props.calcName);
    const calcNameWithPrefix = props.calcName.startsWith("dos_") 
      ? props.calcName 
      : `dos_${props.calcName}`;
    
    console.log("[CalcDos] Looking for ref:", calcNameWithPrefix);
    console.log("[CalcDos] Available refs:", calculators.map(c => c.ref));
    
    const foundCalc = calculators.find(
      (calc: any) => (calc.ref === calcNameWithPrefix || calc.ref === props.calcName) && calc.isReviewed === true
    );

    if (foundCalc) {
      console.log("[CalcDos] Found calculator:", foundCalc.title, foundCalc.ref);
      // Parse calculator JSON if it's a string
      let calculatorData = foundCalc.calculator;
      if (typeof calculatorData === 'string') {
        try {
          console.log("[CalcDos] Parsing calculator JSON string");
          calculatorData = JSON.parse(calculatorData);
          console.log("[CalcDos] Successfully parsed calculator JSON");
        } catch (e) {
          console.error("[CalcDos] Failed to parse calculator JSON", e);
          setLoading(false);
          return;
        }
      } else {
        console.log("[CalcDos] Calculator data is already an object");
      }
      setCalcContent(calculatorData);
      setLoading(false);
    } else {
      console.warn("[CalcDos] Calculator not found. Searched for:", calcNameWithPrefix);
      console.warn("[CalcDos] Available calculators:", calculators.map(c => ({ ref: c.ref, title: c.title })));
      setLoading(false);
    }
  }

  useEffect(() => {
    console.log("[CalcDos] Component mounted/updated, fetching calculators for:", props.calcName);
    fetchCalculators();
  }, [props.calcName]);

  function evalValidator(expression: any) {
    if (!expression || typeof expression !== 'string') return false;
    
    let isValid;
    try {
      new Function(`return ${expression}`);
      isValid = true;
    } catch (e) {
      isValid = false; // A expressão tem erro de sintaxe
    }
    return isValid;
  }

  function visibleEvaluator(object: any) {
    if (!object || !object.visible) return false;
    
    if (object.visible === "true") {
      return true;
    } else if (Object.keys(inputValues).length <= 0) {
      return false;
    } else {
      let conditionalToEval;
      
      // Check if it's the new format (contains inputValues)
      if (object.visible.includes('inputValues[')) {
        let parsedConditional = object.visible;
        // Match patterns like inputValues[ref].value[0].value or inputValues[ref].value.ref
        const inputValuesRegex = /inputValues\[([^\]]+)\]\.value(\[0\])?\.(value|ref)/g;
        let match;
        
        while ((match = inputValuesRegex.exec(object.visible)) !== null) {
          const fullMatch = match[0];
          const ref = match[1];
          const property = match[3]; // 'value' or 'ref'
          const value = inputValues[ref]?.value;
          
          
          if (value !== undefined) {
            let finalValue = value;
            // Navigate through the value structure
            if (Array.isArray(value) && value[0]) {
              // If it's an array, check the property on the first element
              if (property === 'ref' && value[0].ref !== undefined) {
                finalValue = value[0].ref;
              } else if (value[0].value !== undefined) {
                finalValue = value[0].value;
              }
            } else if (typeof value === 'object' && value !== null) {
              // Handle select option objects - check for the requested property
              if (property === 'ref' && value.ref !== undefined) {
                finalValue = value.ref;
              } else if (property === 'value' && value.value !== undefined) {
                finalValue = value.value;
              } else if (value.ref !== undefined) {
                // Fallback: if checking for value but object has ref, use ref
                finalValue = value.ref;
              } else {
                // If it's an object but no matching property, try to stringify it
                finalValue = JSON.stringify(value);
              }
            }
            parsedConditional = parsedConditional.replace(fullMatch, `"${finalValue}"`);
          }
        }
        try {
          const result = eval(parsedConditional);
          return result;
        } catch (error) {
          return false;
        }
      } else {
        // Old format handling (existing code)
        const conditionRegex = /\{(.*?)\}/gi;
        const conditions = object.visible.match(conditionRegex);
        if (!conditions) return false;
        
        let parsedConditional = object.visible
          .replaceAll("{", "")
          .replaceAll("}", "");
        let valueToReturn;
        conditions?.forEach((condition: any) => {
          const parsedCondition = condition.replace("{", "").replace("}", "");
          let value = inputValues?.[parsedCondition]?.value;
          if (value === undefined) {
            conditionalToEval = false;
            return false;
          }
          let finalAttribute = false;
          if (value) {
            while (!finalAttribute) {
              if (typeof value === "string") {
                finalAttribute = true;
              } else if (value && Array.isArray(value) && value.length > 0 && value[0]?.value !== undefined) {
                value = value[0].value;
              } else {
                break;
              }
            }
          }
          const isNumeric = !isNaN(Number(value)) && value !== '';
          parsedConditional = parsedConditional.replace(
            parsedCondition,
            isNumeric ? `${value}` : `"${value || ''}"`
          );
          conditionalToEval = parsedConditional;
        });
        if (conditionalToEval) {
          try {
            valueToReturn = eval(conditionalToEval);
            return valueToReturn;
          } catch (error) {
            return false;
          }
        }
      }
    }
    return false;
  }

  function calculationParser(initialExpression: string, ref: string, round?: string) {
    if (!initialExpression || !ref) return;
    
    const cleanExpression = expressionParser(initialExpression);
    const isValid = evalValidator(cleanExpression);
    
    if (isValid) {
      setFieldsComplete(true);
      try {
        const evaluatedResult = eval(cleanExpression);
        const finalResult =
          round === "true"
            ? Math.round(evaluatedResult)
            : String(parseFloat(Number(evaluatedResult).toFixed(1)));

        const key = String(ref);
        parsedExpressionsRef.current = {
          ...parsedExpressionsRef.current,
          [key]: {
            ...parsedExpressionsRef.current[key],
            value: finalResult,
          },
        };

        setParsedExpressions((prevState: any) => ({
          ...prevState,
          [key]: {
            ...prevState[key],
            value: finalResult,
          },
        }));
      } catch (error) {
        setFieldsComplete(false);
        setResults({});
        setSecondaryResults({});
      }
    } else {
      setFieldsComplete(false);
      setResults({});
      setSecondaryResults({});
    }
  }

  function conditionalParser(
    initialExpression: string,
    ref: string,
    bypassSetter: boolean = false
  ) {
    if (!initialExpression || !ref) return;
    
    const expressionArray = initialExpression.split(";");
    let bypassedResult;
    let conditionMatched = false;
    for (const expression of expressionArray) {
      if (!expression) continue;
      
      const splitExpression = expression.split(")");
      if (splitExpression.length < 2) {
        continue;
      }
      
      const condition = splitExpression[0].replace("if(", "");
      const returnValue = splitExpression[1]
        ?.replace("return", "")
        .replace(" ", "");
      
      // Split condition by && to handle AND conditions
      const conditionParts = condition.split("&&");
      
      const evaluationResults: boolean[] = [];
      
      // Evaluate each condition part
      for (const conditionPart of conditionParts) {
        const trimmedPart = conditionPart.trim();
        
        let iterator: any;
        let evaluationString: string;
        
        if (trimmedPart.includes("parsedExpressions")) {
          // For parsedExpressions, the pattern is: parsedExpressions[ref].value<operator><value>
          const expIndicatorRegex = /\[[^\]]*\]/i;
          const unparsedIndicator = trimmedPart.match(expIndicatorRegex);
          
          if (!unparsedIndicator) {
            evaluationResults.push(false);
            continue;
          }
          
          const parsedIndicator = unparsedIndicator[0]
            .replace("[", "")
            .replace("]", "");
          
          const key = String(parsedIndicator);
          iterator = parsedExpressionsRef.current?.[key]?.value;

          if (iterator === undefined || iterator === null) {
            evaluationResults.push(false);
            continue;
          }
          
          // Extract everything after ".value" as the evaluator
          const valueIndex = trimmedPart.indexOf(".value");
          if (valueIndex === -1) {
            evaluationResults.push(false);
            continue;
          }
          
          const evaluatorPart = trimmedPart.substring(valueIndex + ".value".length);
          
          // Extract operator and comparison value
          const operatorMatch = evaluatorPart.match(/^(===|!==|>=|<=|>|<)/);
          if (!operatorMatch) {
            evaluationResults.push(false);
            continue;
          }
          
          const operator = operatorMatch[1];
          const comparisonValue = evaluatorPart.substring(operator.length).trim();

          const isNumericComparison = (operator === "<=" || operator === ">=" || operator === ">" || operator === "<") &&
            !isNaN(Number(comparisonValue)) && comparisonValue !== "";

          let quotedIterator: any;
          let quotedComparisonValue: any;

          if (isNumericComparison) {
            if (typeof iterator === "string" && !isNaN(Number(iterator)) && iterator.trim() !== "") {
              quotedIterator = Number(iterator);
            } else if (typeof iterator === "number") {
              quotedIterator = iterator;
            } else {
              evaluationResults.push(false);
              continue;
            }
            quotedComparisonValue = Number(comparisonValue);
          } else {
            quotedComparisonValue = comparisonValue;
            if (comparisonValue && isNaN(Number(comparisonValue))) {
              if (!comparisonValue.startsWith('"') && !comparisonValue.startsWith("'")) {
                quotedComparisonValue = `"${comparisonValue}"`;
              }
            }
            quotedIterator = typeof iterator === "string" ? `"${iterator}"` : iterator;
          }

          evaluationString = `${quotedIterator}${operator}${quotedComparisonValue}`;
        } else {
          // Original logic for inputValues - FIXED to properly extract operator
          const expIndicatorRegex = /\[[^\]]*\]/i;
          const unparsedIndicator = trimmedPart.match(expIndicatorRegex);
          
          if (!unparsedIndicator) {
            evaluationResults.push(false);
            continue;
          }
          
          const parsedIndicator = unparsedIndicator[0]
            .replace("[", "")
            .replace("]", "");
          
          // Get everything after the bracket
          const afterBracket = trimmedPart.split(unparsedIndicator[0])[1];
          
          // Find operator in the remaining string (not just at the end)
          const operatorMatch = afterBracket.match(/(===|!==|>=|<=|>|<)/);
          
          if (!operatorMatch) {
            evaluationResults.push(false);
            continue;
          }
          
          const operator = operatorMatch[1];
          const operatorIndex = afterBracket.indexOf(operator);
          const propsPath = afterBracket.substring(0, operatorIndex);
          const comparisonValue = afterBracket.substring(operatorIndex + operator.length).trim();
          
          // Extract props array from props path
          const propsArray = propsPath.split(".").filter(p => p !== "");
          
          // Handle inputValues reference (existing logic)
          iterator = inputValues?.[parsedIndicator];
          propsArray.forEach((prop) => {
            if (prop === "") return;
            if (Object.prototype.toString.call(iterator) === "[object Array]") {
              iterator = iterator?.[0]?.[prop];
            } else {
              iterator = iterator?.[prop];
            }
          });
          
          const isStrictEquality = operator === "===" || operator === "!==";
          const isNumericComparison = !isStrictEquality &&
            (operator === "<=" || operator === ">=" || operator === ">" || operator === "<") &&
            !isNaN(Number(comparisonValue)) && comparisonValue !== '';

          let quotedIterator: any;
          let quotedComparisonValue: any;

          if (isNumericComparison) {
            quotedIterator = typeof iterator === "string" ? Number(iterator) : iterator;
            quotedComparisonValue = Number(comparisonValue);
          } else {
            quotedComparisonValue = comparisonValue;
            if (!comparisonValue.startsWith('"') && !comparisonValue.startsWith("'")) {
              quotedComparisonValue = `"${comparisonValue}"`;
            }
            if (isStrictEquality) {
              quotedIterator = `"${String(iterator)}"`;
            } else {
              quotedIterator = typeof iterator === "string" ? `"${iterator}"` : iterator;
            }
          }
          
          evaluationString = `${quotedIterator}${operator}${quotedComparisonValue}`;
        }
        
        const isValid = evalValidator(evaluationString);
        
        if (!isValid) {
          evaluationResults.push(false);
          continue;
        }
        
        try {
          const evalResult = eval(evaluationString);
          const boolResult = !!evalResult;
          evaluationResults.push(boolResult);
        } catch (error) {
          evaluationResults.push(false);
        }
      }
      
      // All parts must be true (AND logic)
      const allTrue = evaluationResults.length > 0 && evaluationResults.every(result => result === true);
      
      if (allTrue) {
        conditionMatched = true;
        if (bypassSetter) {
          bypassedResult = returnValue;
          break;
        } else {
          const key = String(ref);
          parsedExpressionsRef.current = {
            ...parsedExpressionsRef.current,
            [key]: {
              ...parsedExpressionsRef.current[key],
              value: returnValue,
            },
          };

          setParsedExpressions((prevState: any) => ({
            ...prevState,
            [key]: {
              ...prevState[key],
              value: returnValue,
            },
          }));
          break;
        }
      }
    }

    if (!bypassSetter && !conditionMatched) {
      const key = String(ref);
      if (parsedExpressionsRef.current?.[key]?.value !== undefined) {
        parsedExpressionsRef.current = {
          ...parsedExpressionsRef.current,
          [key]: {
            ...parsedExpressionsRef.current[key],
            value: undefined,
          },
        };
        setParsedExpressions((prevState: any) => ({
          ...prevState,
          [key]: {
            ...prevState[key],
            value: undefined,
          },
        }));
      }
    }

    if (bypassSetter) {
      return bypassedResult;
    }
  }

  function inputValuesHelper(unparsed: string) {
    const ipValuesKeysRegex = /inputValues\[[^\]]*\]/gi;
    const ipValuesKey = unparsed.match(ipValuesKeysRegex);
    let valueToReturn = {};
    if (ipValuesKey) {
      ipValuesKey.forEach((key: string) => {
        const replaceLocation = key + unparsed.split(key)[1];
        const parsedkey = key
          .replace("inputValues", "")
          .replace("[", "")
          .replace("]", "");
        const props = unparsed.split(key)[1].split(".");
        let accumulator = inputValues[parsedkey];
        props.forEach((prop: string) => {
          if (prop === "") {
            return;
          } else {
            if (accumulator) {
              accumulator = accumulator[prop];
            }
          }
        });
        valueToReturn = { value: accumulator, whereToReplace: replaceLocation };
      });
      return valueToReturn;
    } else {
      return unparsed;
    }
  }

  function expressionParser(initialExpression: string) {
    if (!initialExpression || typeof initialExpression !== 'string') return '';
    
    const regex = /inputValues\[[^\]]*\]/gi;
    const expressionVariablesArray = [...initialExpression.matchAll(regex)];
    //@ts-ignore
    let cleanExpression = initialExpression.replaceAll(";", "");
    for (let index = 0; index < expressionVariablesArray.length; index++) {
      const expression = expressionVariablesArray[index];
      if (!expression) continue;
      
      const initialObject = initialExpression
        .split(";")
        .filter((prop) => prop.includes("inputValues"));
      if (!initialObject[index]) continue;
      
      const ObjectProps = initialObject[index].split(".");
      let propsAccumulator = "";
      let value;
      ObjectProps.shift();
      const expressionIndicator = expression[0]
        .replace("inputValues[", "")
        .replace("]", "");
      ObjectProps.forEach((prop, i) => {
        if (i < ObjectProps.length - 1) {
          propsAccumulator += prop + ".";
        } else {
          propsAccumulator += prop;
        }
      });
      const splitProps = propsAccumulator.split(".");
      if (splitProps.length > 1) {
        let iterator = inputValues?.[expressionIndicator];
        splitProps.forEach((prop) => {
          if (Array.isArray(iterator)) {
            iterator = iterator?.[0]?.[prop];
          } else {
            iterator = iterator?.[prop];
          }
        });
        value = iterator;
      } else {
        value = inputValues?.[expressionIndicator]?.[propsAccumulator];
      }
      cleanExpression = cleanExpression.replace(
        expression[0] + "." + propsAccumulator,
        value || ''
      );
    }
    return cleanExpression;
  }

  // Reconstruct conditional string from originalResult array (same logic as Formulator.conditionalParser)
  function reconstructConditionalFromOriginal(originalResult: any[]): string {
    let conditional = "REMOVETHIS";
    originalResult.forEach((value: any) => {
      if (value.type) {
        if (value.type === "select") {
          if (value.options && value.options[0] && value.options[0].value && value.options[0].value.concentration) {
            conditional += `inputValues[${value.ref}].value.ref`;
          } else {
            conditional += `inputValues[${value.ref}].value.value`;
          }
        } else {
          conditional += `inputValues[${value.ref}].value`;
        }
      } else if (value.label && value.value) {
        if (value.value.concentration) {
          conditional += `${value.value.ref}`;
        } else if (Array.isArray(value.value) && value.value[0]) {
          conditional += `${value.value[0].value}`;
        } else if (typeof value.value === 'object' && value.value.value !== undefined) {
          conditional += `${value.value.value}`;
        } else {
          conditional += `${value.value}`;
        }
      } else {
        if (value.value === "if") {
          conditional += ";" + value.value;
        } else {
          if (value.value === "return") {
            conditional += `${value.value} `;
          } else {
            conditional += value.value;
          }
        }
      }
    });
    return conditional.replace("REMOVETHIS;", "");
  }

  function secondaryResultsParser(fullObj: any) {
    if (!fullObj?.secondaryResults || !Array.isArray(fullObj.secondaryResults)) {
      setSecondaryResults([]);
      return;
    }
    
    let temp: { result: string; title: string; resultColor?: string }[] = [];
    let isValid = false;
    fullObj.secondaryResults.forEach((secondary: any) => {
      if (!secondary?.result) {
        return;
      }
      
      // Check if this is an aviso (type warning) - avisos have conditional expressions directly in result field
      const isAviso = secondary.type === "warning";
      
      if (isAviso) {
        // If result is empty but originalResult exists, reconstruct result from originalResult
        let resultString = secondary.result;
        if ((!resultString || !resultString.trim()) && secondary.originalResult && Array.isArray(secondary.originalResult)) {
          // Reconstruct the conditional string from originalResult array
          resultString = reconstructConditionalFromOriginal(secondary.originalResult);
        }
        
        // For avisos, check if result contains a conditional expression
        // If it's a conditional (contains if(...)return...), evaluate it
        // Otherwise, just use the result as-is (plain text)
        if (resultString && resultString.trim()) {
          const hasConditional = resultString.includes('if(') && resultString.includes('return');
          
          if (hasConditional) {
            // Parse and evaluate the conditional expression
            const conditionalResult = conditionalParser(
              resultString,
              secondary.ref || `aviso-${Date.now()}`,
              true
            );
            // Only add if we got a valid result (not REMOVETHIS, undefined, null, or empty)
            if (conditionalResult !== undefined && 
                conditionalResult !== null && 
                conditionalResult !== '' && 
                String(conditionalResult).trim() !== '' &&
                String(conditionalResult) !== 'REMOVETHIS') {
              temp.push({
                result: String(conditionalResult),
                title: secondary.title || '',
                resultColor: "red",
              });
            }
          } else {
            // Plain text aviso - only add if it's not REMOVETHIS
            if (resultString !== 'REMOVETHIS' && resultString.trim() !== 'REMOVETHIS') {
              temp.push({
                result: resultString,
                title: secondary.title || '',
                resultColor: "red",
              });
            }
          }
        }
        return;
      }
      
      // Original logic for secondary results with formulas
      if (!secondary?.formulas) return;
      
      let parsedResult = secondary.result;
      secondary.formulas.forEach((formula: any) => {
        if (!formula) return;
        
        //@ts-ignore
        if (formula.type && formula.type === "conditional") {
          const result = conditionalParser(
            formula.expression,
            formula.ref,
            true
          );
          isValid = true;
          const placeholder = `{${formula.ref}}`;
          parsedResult =
            (parsedResult || "").split(placeholder).join(result || "");
        } else {
          const result = expressionParser(formula.expression);
          isValid = evalValidator(result);
          if (isValid) {
            try {
              let parsed;
              if (formula.round === "true") {
                parsed = Math.round(eval(result));
              } else {
                parsed = eval(result);
              }
              // Don't set parsedExpressions here - it causes infinite loop
              // The value is already calculated in the main useEffect
              // Just use the value from parsedExpressions if available, otherwise use calculated value
              const valueToUse = parsedExpressions[formula.ref]?.value !== undefined 
                ? parsedExpressions[formula.ref].value 
                : parsed;
              const placeholder = `{${formula.ref}}`;
              parsedResult =
                (parsedResult || "").split(placeholder).join(valueToUse || "");
            } catch (error) {
              isValid = false;
            }
          }
        }
      });
      if (isValid) {
        temp.push({
          result: parsedResult,
          title: secondary.title || '',
          resultColor: secondary.color,
        });
      }
    });
    setSecondaryResults(temp);
  }

  function resultsParser(fullObj: any) {
    if (!fieldsComplete || !fullObj?.results || !Array.isArray(fullObj.results)) {
      return;
    } else {
      fullObj.results.forEach((result: any) => {
        if (!result || !visibleEvaluator(result)) {
          return;
        } else {
          // Handle result field - check if it's a formula reference or direct input references
          let parsedResult = '';
          if (result.result && result.result.startsWith('{') && result.result.endsWith('}')) {
            // It's a formula reference, get the calculated value from parsedExpressions
            const formulaRef = result.result.replace('{', '').replace('}', '');
            parsedResult = parsedExpressions[formulaRef]?.value || '';
          } else {
            // It's direct input references, parse them normally
          const resultRegex = /\{(.*?)\}/g;
          parsedResult = result.result || "";
          let match;

          while ((match = resultRegex.exec(result.result || "")) !== null) {
            const variableName = match[1];
            const value = parsedExpressions[variableName]?.value || "";
            const placeholder = `{${variableName}}`;
            parsedResult = parsedResult.split(placeholder).join(value);
          }
          }
          
          // Handle subtitle - parse inputValues references to get actual values
          let parsedSubtitle = result.subtitle || "";
          if (result.subtitle && result.subtitle.includes('inputValues[')) {
            const inputValuesRegex = /inputValues\[([^\]]+)\]/g;
            let match;
            while ((match = inputValuesRegex.exec(result.subtitle)) !== null) {
              const fullMatch = match[0];
              const ref = match[1];
              const props = result.subtitle.split(fullMatch)[1]?.split(' ')[0] || '';
              
              // Navigate through the props to get the actual value
              let value = inputValues[ref];
              if (value && props) {
                const propArray = props.split('.').filter((p: string) => p);
                propArray.forEach((prop: string) => {
                  if (value && typeof value === 'object') {
                    if (Array.isArray(value) && value[0]) {
                      value = value[0][prop];
                    } else {
                      value = value[prop];
                    }
                  }
                });
              }
              
              // Replace the inputValues reference with the actual value
              parsedSubtitle = parsedSubtitle.replace(fullMatch + props, value || '');
            }
          }
          setResults({
            title: result.title || '',
            value: parsedResult || '',
            subtitle: parsedSubtitle.replace('REMOVETHIS;', '') || '',
          });
        }
      });
    }
  }

  function inputSorter(input: any) {
    if (!input) return null;
    
    const isVisible = visibleEvaluator(input);
    if (!isVisible) {
      return null;
    } else {
      if (input.type === "text") {
        return (
          <CalculatorBasicInput
            title={input.title || ''}
            placeHolder={input.unity && input.unity.length > 0 ? input.unity[0] : 'Sem unidade'}
            key={input.ref || input.id}
            keyboardType="decimal"
            value={inputValues[input.ref || input.id]?.value?.replace(/^0+/, "") || ""}
            initialState={initialState}
            valueSetter={(e) =>
              setInputValues((prevState: any) => ({
                ...prevState,
                [input.ref || input.id]: {
                  ...prevState[input.ref || input.id],
                  value: e.replace(/^0+/, ""),
                  type: "text",
                },
              }))
            }
          />
        );
      }
      if (input.type === "select") {
        return (
          <CalculatorMultipleOptions
            initialState={initialState}
            title={input.title || ''}
            key={input.ref || input.id}
            valueArray={input.options || []}
            valueSetter={(e) => {
              setInputValues((prevState: any) => ({
                ...prevState,
                [input.ref || input.id]: {
                  value: e,
                  type: "select",
                },
              }));
            }}
          />
        );
      }
    }
    return null;
  }

  useEffect(() => {
    if (!calcContent?.results || !Array.isArray(calcContent.results)) return;

    calcContent.results.forEach((result: any) => {
      if (!result) return;
      if (!result.formulas || !Array.isArray(result.formulas)) return;

      result.formulas.forEach((formula: any) => {
        if (!formula || formula.type !== "calculation") return;
        calculationParser(formula.expression, formula.ref, formula.round);
      });
    });

    if (calcContent?.secondaryResults && Array.isArray(calcContent.secondaryResults)) {
      calcContent.secondaryResults.forEach((secondary: any) => {
        if (secondary?.type === "warning" && secondary?.formulas && Array.isArray(secondary.formulas)) {
          secondary.formulas.forEach((formula: any) => {
            if (!formula || formula.type !== "calculation") return;
            calculationParser(formula.expression, formula.ref, formula.round);
          });
        }
      });
    }

    calcContent.results.forEach((result: any) => {
      if (!result) return;
      if (!result.formulas || !Array.isArray(result.formulas)) return;

      result.formulas.forEach((formula: any) => {
        if (!formula || formula.type !== "conditional") return;
        conditionalParser(formula.expression, formula.ref);
      });
    });

    if (calcContent?.secondaryResults && Array.isArray(calcContent.secondaryResults)) {
      calcContent.secondaryResults.forEach((secondary: any) => {
        if (secondary?.type === "warning" && secondary?.formulas && Array.isArray(secondary.formulas)) {
          secondary.formulas.forEach((formula: any) => {
            if (!formula || formula.type !== "conditional") return;
            conditionalParser(formula.expression, formula.ref);
          });
        }
      });
    }

    secondaryResultsParser(calcContent);
  }, [inputValues]);

  useEffect(() => {
    resultsParser(calcContent);
    secondaryResultsParser(calcContent);
  }, [parsedExpressions]);

  // Validation function to check if calculator has minimum required data
  const isValidCalculator = () => {
    if (!calcContent) return false;
    if (!calcContent.title || typeof calcContent.title !== 'string' || calcContent.title.trim() === '') return false;
    if (!Array.isArray(calcContent.inputs) || calcContent.inputs.length === 0) return false;
    if (!Array.isArray(calcContent.results) || calcContent.results.length === 0) return false;
    return true;
  };

  // Show loading while fetching
  if (loading) {
    return <BBLoadingGif />;
  }

  // Early return if calculator is not valid
  if (!isValidCalculator()) {
    return <BBLoadingGif />;
  }

  return (
    <>
      <Main>
        <Container>
          <CalculatorContainer>
            <TitleContainer>
              <CalculatorTitle>{calcContent.title || ''}</CalculatorTitle>
            </TitleContainer>
            <ContentContainer>
              {calcContent.inputs?.map((input: any) => inputSorter(input))}
            </ContentContainer>
            <ClearButton onClick={() => setInitialState(!initialState)}>
              LIMPAR
            </ClearButton>
          </CalculatorContainer>
        </Container>
        <CalcDosResults
          primaryResult={results && results.value ? results.value : ''}
          secondaryResults={secondaryResults || []}
          initialState={initialState}
          info={calcContent.info || ''}
          title={results?.title ? (results?.subtitle ? `${results.title} - ${results.subtitle}` : results.title) : ''}
        />
      </Main>
    </>
  );
};

export default CalcDos;
